// const tableCustomStyles = {
//   rows: {
//     style: {
//     },
//   },
//   cells: {
//     style: {
//       justifyContent: "center"
//     },
//   },
//   headCells: {
//     style: {
//       color: "#5C5C5C",
//       justifyContent: "center",
//       color: "rgb(33,37,41)",
//       fontSize: "12px",
//       fontWeight: 500,
//       lineHeight: "28px",
//     },
//   },
// }
// export default tableCustomStyles

const tableCustomStyles = {
  table: {
    style: {
      backgroundColor: "#fff",
      borderRadius: "18px",
      overflow: "hidden",
      border: "1px solid #e8e8e8",
      margin: "10px 10px"
    },
  },

  headRow: {
    style: {
      minHeight: "68px",
      borderBottom: "1px solid #ececec",
      backgroundColor: "#fff",
    },
  },

  headCells: {
    style: {
      fontSize: "11px",
      fontWeight: "500",
      color: "#6b7280",
      textTransform: "uppercase",
      letterSpacing: "1px",
      fontFamily: "Inter, sans-serif",
      paddingLeft: "18px",
      paddingRight: "18px",
    },
  },

  rows: {
    style: {
      minHeight: "78px",
      borderBottom: "1px solid #f1f1f1",
      fontSize: "13px",
      fontWeight: 500,
      fontFamily: "Inter, sans-serif",
    },
  },

  cells: {
    style: {
      paddingLeft: "18px",
      paddingRight: "18px",
      whiteSpace: "normal",
      lineHeight: "15px",
    },
  },

  pagination: {
    style: {
      borderTop: "1px solid #ececec",
      minHeight: "60px",
    },
  },
};
export default tableCustomStyles;